import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "redux"
import { translate } from "react-i18next"
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import styled from "styled-components"

const ThemedDropdownToggle = styled(DropdownToggle)`
  background-color: ${prop => prop.toggleBackColor} !important;
  border-color: ${prop => prop.toggleColor} !important;
  color: ${prop => prop.toggleColor} !important;
  &:hover {
    background-color: ${prop => prop.hoverColor};
    border-color: ${prop => prop.hoverColor};
    color: #ffffff;
  }
`

const ThemedDropdownItem = styled(DropdownItem)`
  color: ${prop => prop.hoverColor};
  font-size: 14px;
  &:hover {
    color: ${prop => prop.hoverColor};
    cursor: pointer;
  }
`

class LanguagePicker extends Component {
  constructor(props) {
    super(props)
    const i18nCurrentLang = props.i18n.language // eslint-disable-line react/prop-types

    const clientCultures = props.userDetails.client.availableCultures

    const currentLanguage = clientCultures.find(x => x.Code === i18nCurrentLang)

    this.state = {
      dropdownOpen: false,
      lngName: currentLanguage ? currentLanguage.Name : null,
      clientCultures,
    }
  }

  changeLanguage = (e, lng) => {
    this.setState({ lngName: lng.Name })
    this.props.i18n.changeLanguage(lng.Code) // eslint-disable-line react/prop-types
  }

  toggle = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    })
  }

  render() {
    // Don't render anything if there's only one language
    if (!this.state.clientCultures || this.state.clientCultures.length <= 1) {
      return null
    }

    const toggleBackColor = this.state.dropdownOpen
      ? this.props.userDetails.theme.primaryColor
      : "#ffffff"
    const toggleColor = this.state.dropdownOpen
      ? "#ffffff"
      : this.props.userDetails.theme.primaryColor
    const hoverColor = this.props.userDetails.theme.primaryColor

    return (
      <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} dropup>
        <ThemedDropdownToggle
          caret
          size="sm"
          toggleBackColor={toggleBackColor}
          toggleColor={toggleColor}
          hoverColor={hoverColor}
        >
          {this.state.lngName}
        </ThemedDropdownToggle>
        <DropdownMenu>
          {this.state.clientCultures.map(lng => (
            <ThemedDropdownItem
              key={lng.Code}
              hoverColor={hoverColor}
              onClick={e => this.changeLanguage(e, lng)}
            >
              {lng.Name}
            </ThemedDropdownItem>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    )
  }
}

function mapStateToProps(state) {
  return {
    userDetails: state.userDetail,
  }
}

LanguagePicker.propTypes = {
  userDetails: PropTypes.shape({
    authenticated: PropTypes.bool.isRequired,
    culture: PropTypes.string,
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    client: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subdomain: PropTypes.string.isRequired,
      availableCultures: PropTypes.arrayOf(PropTypes.shape({
        Code: PropTypes.string.isRequired,
        Name: PropTypes.string.isRequired,
      })),
    }),
  }).isRequired,
}

export default compose(translate(), connect(mapStateToProps))(LanguagePicker)



// WEBPACK FOOTER //
// ./src/components/LanguagePicker.jsx